import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createMigrate, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  dmpconnect,
  dmpconnectCPxConfiguration,
  dmpconnectInit,
  getDmpconnectConnectorConfigReducer,
  getDmpconnectDpConfigReducer,
  getDmpconnectEsConfigReducer,
  getDmpconnectTSEConfigReducer,
  getDmpconnectINSiConfigReducer,
  getDmpconnectALDiConfigReducer,
  dmpconnectMonitoring,
} from 'dmpconnectjsapp-base/reducers';
import getDmpconnectApCvConfigReducer from 'dmpconnectjsapp-base/reducers/dmpconnectApCvConfiguration';
import getDmpconnectPersistedConnectorConfiguration
  from 'dmpconnectjsapp-base/reducers/dmpconnectPersistedConnectorConfiguration';
import { apiSections, mssReceiptNotificationTypes } from 'dmpconnectjsapp-base/constants';
import { mssSubTypes } from 'dmpconnectjsapp-base/actions/config/commands';
import getDmpconnectMSSConfigReducer from 'dmpconnectjsapp-base/reducers/dmpconnectMSSConfiguration';
import {
  dmpconnectAccessibleDmpList,
  dmpconnectApplication,
  dmpconnectDocumentsCache,
  dmpconnectPDFs,
  dmpConnectPersistedAppConfiguration,
  dmpconnectRemote,
  dmpconnectUser,
  dmpconnectVirtualPrinter,
} from '../dmpconnect/reducers';
import env from '../envVariables';
import {
  aldConfigFromEnv, apCvConfigFromEnv,
  connectorConfigFromEnv,
  dpConfigFromEnv,
  esConfigFromEnv, insiConfigFromEnv, mssConfigFromEnv, persistedConnectorConfigFromEnv,
  tseConfigFromEnv,
} from './configFromEnv';
import { dmpconnectFilters } from '../dmpconnect/reducers/dmpconnectFilters';
import { news } from '../dmpconnect/reducers/news';
import { dmpLandingPages } from '../dmpconnect/constants';
import { openIDConfiguration } from '../dmpconnect/reducers/openIDConfiguration';
import { mssMessages } from '../dmpconnect/reducers/mssMessages';
import { esRestPersistantData } from '../dmpconnect/reducers/esRestPersistantData';

export const storages = [];
function customPersistReducer(config, reducer) {
  storages.push(config.key);
  return persistReducer(config, reducer);
}

const dmpconnectConnectorConfig = getDmpconnectConnectorConfigReducer(connectorConfigFromEnv);
const dmpconnectPersistedConnectorConfig = getDmpconnectPersistedConnectorConfiguration(persistedConnectorConfigFromEnv);
const dmpconnectESConfiguration = getDmpconnectEsConfigReducer(esConfigFromEnv);
const dmpconnectTSEConfiguration = getDmpconnectTSEConfigReducer(tseConfigFromEnv);
const dmpconnectDpConfiguration = getDmpconnectDpConfigReducer(dpConfigFromEnv);
const dmpconnectINSiConfiguration = getDmpconnectINSiConfigReducer(insiConfigFromEnv);
const dmpconnectALDiConfiguration = getDmpconnectALDiConfigReducer(aldConfigFromEnv);
const dmpconnectApCvConfiguration = getDmpconnectApCvConfigReducer(apCvConfigFromEnv);
const dmpconnectMSSConfiguration = getDmpconnectMSSConfigReducer(mssConfigFromEnv);

const rootPersistConfig = {
  key: 'efficience_root',
  storage,
  whitelist: [
    'news',
    'dmpconnectUser',
    'dmpconnectCPxConfiguration',
    'dmpConnectPersistedAppConfiguration',
    'dmpconnectPersistedConnectorConfiguration',
    'dmpconnectTSEConfiguration',
  ],
  version: 22,
  migrate: createMigrate(
    {
      // migration from version 1 to version 2
      2: state => ({
        ...state,
        dmpconnectINSiConfiguration: { ...insiConfigFromEnv },
        dmpconnectALDiConfiguration: { ...aldConfigFromEnv },
      }),
      3: state => ({
        ...state,
        production_mode: Number(env.REACT_APP_PRODUCTON_MODE) === 1,
      }),
      4: state => ({
        ...state,
        dmpconnectApCvConfiguration: { ...apCvConfigFromEnv },
      }),
      5: state => ({
        ...state,
        dmpconnectPersistedConnectorConfiguration: {
          ...state.dmpconnectPersistedConnectorConfiguration,
          nfcCardReader: -1,
        },
      }),
      // remove services config from general state
      7: (state) => {
        const {
          dmpconnectINSiConfiguration: insi,
          dmpconnectALDiConfiguration: aldi,
          dmpconnectApCvConfiguration: apcv,
          dmpconnectDpConfiguration: dp,
          ...newState
        } = state;
        return { ...newState };
      },
      8: state => ({
        ...state,
        dmpconnectConnectorConfig: {
          ...state.dmpconnectConnectorConfig,
          applicationId: connectorConfigFromEnv.applicationId,
        },
      }),
      9: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          dmpLandingPage: env.REACT_APP_DMP_LANDING_PAGE || dmpLandingPages.PARCOURS_SOIN,
        },
      }),
      10: state => ({
        ...state,
        dmpconnectConnectorConfig: {
          ...state.dmpconnectConnectorConfig,
          applicationId: env.REACT_APP_ID,
        },
      }),
      11: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          cpxLoginType: 'CPX',
        },
      }),
      12: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          cpxLoginToken: null,
        },
      }),
      13: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          vitaleAutoRead: Number(env.REACT_APP_VITALE_AUTO_READ) === 1,
        },
      }),
      14: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          nfcReaderActive: true,
          qrCodeReaderActive: true,
        },
      }),
      15: (state) => {
        const {
          dmpConnectPersistedAppConfiguration: {
            nfcReaderActive,
            qrCodeReaderActive,
            ...newPersistedAppState
          },
          ...newState
        } = state;
        return {
          dmpConnectPersistedAppConfiguration: {
            ...newPersistedAppState,
          },
          ...newState,
        };
      },
      // fix
      16: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          cpxLoginToken: null,
          cpxLoginType: 'CPX',
          vitaleAutoRead: Number(env.REACT_APP_VITALE_AUTO_READ) === 1,
        },
      }),
      17: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          hideConfig: Number(env.REACT_APP_HIDE_CONFIG) === 1,
          hideMailiz: Number(env.REACT_APP_HIDE_MAILIZ) === 1,
          noDashboard: Number(env.REACT_APP_DEACTIVATE_DASHBOARD) === 1,
          mssReceiptNotificationType: mssReceiptNotificationTypes[env.REACT_APP_MSS_RECEIPT_NOTIFICATION_TYPE],
          hideNewsSidebar: Number(env.REACT_APP_HIDE_NEWS_SIDEBAR) === 1,
        },
      }),
      18: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          mssApiType: env.REACT_APP_MSS_API_TYPE || mssSubTypes.IMAP,
        },
      }),
      19: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          ignorePdfA1Transparency: Number(env.REACT_APP_PDFA1_CONVERSION_IGNORE_TRANSPARENCY) === 1,
          disabledPdfA1Conversion: Number(env.REACT_APP_PDFA1_CONVERSION_DISABLE) === 1,
        },
      }),
      20: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          remoteControlDisableExports: Number(env.REACT_APP_REMOTE_CONTROL_DISABLE_EXPORTS) === 1,
        },
      }),
      21: state => ({
        ...state,
        dmpconnectConnectorConfig: {
          ...state.dmpconnectConnectorConfig,
          webPsRootUrl: env.REACT_APP_WEB_PS_BASE_URL,
        },
      }),
      22: state => ({
        ...state,
        dmpConnectPersistedAppConfiguration: {
          ...state.dmpConnectPersistedAppConfiguration,
          mssApiType: env.REACT_APP_MSS_API_TYPE,
        },
      }),
    },
    { debug: true },
  ),
};

if (Number(env.REACT_APP_DEBUG) === 1) {
  rootPersistConfig.whitelist.push('dmpconnectConnectorConfig');
}

const dmpconnectPersistConfig = {
  key: 'efficience_commands',
  storage,
  version: 1,
  blacklist: [
    apiSections.DOCUMENT_CONTENT_SECTION,
    apiSections.MSS_DOWNLOAD_ATTACHMENT,
    apiSections.MSS_GET_MESSAGE_CONTENT,
    apiSections.GET_DOCS_FROM_IHE_XDM,
  ],
};
const dmpconnectESPersistConfig = {
  key: 'efficience_es_config',
  storage,
  version: 5,
  migrate: createMigrate({
    2: state => ({
      ...state,
      hpAuthenticationContext: esConfigFromEnv.hpAuthenticationContext,
      hpAuthenticationMode: esConfigFromEnv.hpAuthenticationMode,
    }),
    3: state => ({
      ...state,
      loginApiExtraHeaders: env.REACT_APP_ES_LOGIN_API_EXTRA_HEADER,
      loginCheckApi: Number(env.REACT_APP_ES_LOGIN_CHECK_API) === 1,
      loginCheckApiEndpoint: env.REACT_APP_ES_LOGIN_CHECK_API_ENDPOINT,
      loginCheckApiPSParam: env.REACT_APP_ES_LOGIN_CHECK_API_ENDPOINT_PS_PARAM,
      loginCheckApiPatientParam: env.REACT_APP_ES_LOGIN_CHECK_API_ENDPOINT_PATIENT_PARAM,
    }),
    4: state => ({
      ...state,
      es_id_mss: env.REACT_APP_ES_ID_MSS,
    }),
    5: state => ({
      ...state,
      esMssCertificate: env.REACT_APP_ES_CERT_MSS,
    }),
  }),
};
const dmpconnectPDFsPersistConfig = {
  key: 'efficience_PDFs',
  storage,
  version: 1,
};
const dmpconnectAccessibleDmpListPersistConfig = {
  key: 'efficience_td04',
  storage,
  version: 1,
};
const dmpconnectDocumentsCachePersistConfig = {
  key: 'efficience_documents',
  storage,
  version: 1,
};
const dmpconnectFiltersPersistConfig = {
  key: 'efficience_filters',
  storage,
  version: 1,
};
const dmpconnectINSiConfigurationPersistConfig = {
  key: 'efficience_insi_config',
  storage,
  version: 1,
};
const dmpconnectALDiConfigurationPersistConfig = {
  key: 'efficience_aldi_config',
  storage,
  version: 1,
};
const dmpconnectApCvConfigurationPersistConfig = {
  key: 'efficience_apcv_config',
  storage,
  version: 3,
  migrate: createMigrate({
    2: state => ({
      ...state,
      startDate: env.REACT_APP_APCV_START_DATE,
    }),
    3: state => ({
      ...state,
      nfcReaderActive: true,
      qrCodeReaderActive: true,
    }),
  }),
};
const dmpconnectDpConfigurationPersistConfig = {
  key: 'efficience_dp_config',
  storage,
  version: 1,
};
const openIDPersistConfig = {
  key: 'efficience_openid_config',
  storage,
  version: 1,
};
const mssMessagesPersisConfig = {
  key: 'efficience_mss_messages',
  storage,
};
const dmpconnectMSSConfigurationPersistConfig = {
  key: 'efficience_mss_config',
  storage,
  version: 1,
};
const esRestPersistantDataPersistConfig = {
  key: 'efficience_es-rest_persistant_data',
  storage,
};


const createRootReducer = history => combineReducers({
  router: connectRouter(history),

  // external connector
  dmpconnect: customPersistReducer(dmpconnectPersistConfig, dmpconnect),
  dmpconnectInit,

  dmpconnectConnectorConfig,
  dmpconnectCPxConfiguration,
  dmpconnectESConfiguration: customPersistReducer(dmpconnectESPersistConfig, dmpconnectESConfiguration),
  dmpconnectTSEConfiguration,
  dmpconnectPersistedConnectorConfiguration: dmpconnectPersistedConnectorConfig,

  // services
  dmpconnectINSiConfiguration: Number(env.REACT_APP_DEBUG) === 1
    ? customPersistReducer(dmpconnectINSiConfigurationPersistConfig, dmpconnectINSiConfiguration)
    : dmpconnectINSiConfiguration,
  dmpconnectALDiConfiguration: Number(env.REACT_APP_DEBUG) === 1
    ? customPersistReducer(dmpconnectALDiConfigurationPersistConfig, dmpconnectALDiConfiguration)
    : dmpconnectALDiConfiguration,
  dmpconnectApCvConfiguration: Number(env.REACT_APP_DEBUG) === 1
    ? customPersistReducer(dmpconnectApCvConfigurationPersistConfig, dmpconnectApCvConfiguration)
    : dmpconnectApCvConfiguration,
  dmpconnectDpConfiguration: customPersistReducer(dmpconnectDpConfigurationPersistConfig, dmpconnectDpConfiguration),
  dmpconnectMSSConfiguration: customPersistReducer(dmpconnectMSSConfigurationPersistConfig, dmpconnectMSSConfiguration),

  // application
  esRestPersistantData: customPersistReducer(esRestPersistantDataPersistConfig, esRestPersistantData),
  news,
  dmpconnectUser,
  dmpconnectFilters: customPersistReducer(dmpconnectFiltersPersistConfig, dmpconnectFilters),
  dmpconnectMonitoring,
  dmpconnectApplication,
  dmpConnectPersistedAppConfiguration,
  dmpconnectRemote,
  dmpconnectVirtualPrinter,
  // dmpconnectPDFs,
  dmpconnectPDFs: customPersistReducer(dmpconnectPDFsPersistConfig, dmpconnectPDFs),
  dmpconnectAccessibleDmpList: customPersistReducer(dmpconnectAccessibleDmpListPersistConfig, dmpconnectAccessibleDmpList),
  dmpconnectDocumentsCache: customPersistReducer(dmpconnectDocumentsCachePersistConfig, dmpconnectDocumentsCache),
  openIDConfiguration: customPersistReducer(openIDPersistConfig, openIDConfiguration),


  // mss
  mssMessages: customPersistReducer(mssMessagesPersisConfig, mssMessages),
});

export default history => customPersistReducer(rootPersistConfig, createRootReducer(history));
